export default function getFavorites(): String[] {
  return (localStorage.getItem('favorites') && JSON.parse(localStorage.getItem('favorites')!) as String[]) || [];
} 